var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { grow: "" } },
    [
      _c("w-card-title", [_vm._v(" " + _vm._s(_vm.chartData.title) + " ")]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content", "no-padding": "" } },
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _vm._l(_vm.additionalYears, function (year, i) {
                return _c(
                  "w-col",
                  {
                    key: year.BookYear,
                    attrs: { xs: _vm.colWidth, "no-margin": "" },
                  },
                  [
                    _c("div", { staticClass: "tiny-total" }, [
                      _vm._v(
                        " € " + _vm._s(_vm.printHumanFloat(year.Value)) + " "
                      ),
                      i != 0
                        ? _c(
                            "span",
                            {
                              staticClass: "profit",
                              class: { negative: year.profitPercentage < 0 },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getPercentageString(year.profitPercentage)
                                ) + "%"
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("span", { staticClass: "year-field" }, [
                        _vm._v(" (" + _vm._s(year.BookYear) + ") "),
                      ]),
                    ]),
                  ]
                )
              }),
              !_vm.chartData.hideLastMonth
                ? _c(
                    "w-col",
                    { attrs: { xs: _vm.colWidth, "no-margin": "" } },
                    [
                      _c("div", { staticClass: "tiny-total" }, [
                        _vm._v(
                          " € " +
                            _vm._s(_vm.printHumanFloat(_vm.lastMonthRevenue)) +
                            " "
                        ),
                        _c("span", { staticClass: "year-field" }, [
                          _vm._v(" (" + _vm._s(_vm.previousMonthName) + ") "),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c("w-col", { attrs: { xs: _vm.colWidth, "no-margin": "" } }, [
                _c("div", { staticClass: "tiny-total" }, [
                  _vm._v(
                    " € " +
                      _vm._s(_vm.printHumanFloat(_vm.currentMonthRevenue)) +
                      " "
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "profit",
                      class: { negative: _vm.profitPercentage < 0 },
                    },
                    [_vm._v(_vm._s(_vm.profitPercentageString) + "%")]
                  ),
                  _c("span", { staticClass: "year-field" }, [
                    _vm._v(" (" + _vm._s(_vm.currentMonthName) + ") "),
                  ]),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }